import type { Config } from '@/config/types.ts';

// 生产环境配置
const config: Partial<Config> = {
  mobileBaseUrl: 'https://mcar.chemt.cn',
};

export default config;
